import type {FavoriteKind} from './schema';

/**
 * Product events the shared hooks report (#379). Each app turns them into
 * its own SDK call (mobile Firebase Analytics, webapp gtag) through the
 * sender it configures; core never knows which.
 */
export type CoreAnalyticsEvent = {
  name: 'favorite_add' | 'favorite_remove';
  params: {kind: FavoriteKind};
};

type Sender = (event: CoreAnalyticsEvent) => void;

let sender: Sender | null = null;

/** Set at app start; `null` stops reporting. */
export const configureAnalyticsSink = (next: Sender | null) => {
  sender = next;
};

/**
 * Report an event. Unconfigured, nothing is sent, and a failing sender never
 * breaks the action that reported.
 */
export const trackCoreEvent = (event: CoreAnalyticsEvent) => {
  try {
    sender?.(event);
  } catch {
    // Analytics must never break the user's action.
  }
};
